/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  Webhook,
  RemoveWebhookBody,
  ListWebhooks200,
  CreateWebhookBody
} from './schema'



/**
 * Remove a Webhook
 * @summary Remove Webhook
 */
export const removeWebhook = (
    removeWebhookBody: RemoveWebhookBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Webhook>> => {
    return axios.post(
      `/webhooks/remove`,
      removeWebhookBody,options
    );
  }



    export type RemoveWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof removeWebhook>>>
    export type RemoveWebhookMutationBody = RemoveWebhookBody
    export type RemoveWebhookMutationError = AxiosError<unknown>

    export const useRemoveWebhook = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeWebhook>>, TError,{data: RemoveWebhookBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeWebhook>>, {data: RemoveWebhookBody}> = (props) => {
          const {data} = props ?? {};

          return  removeWebhook(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof removeWebhook>>, TError, {data: RemoveWebhookBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * List all Webhooks

 * @summary List Webhooks
 */
export const listWebhooks = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ListWebhooks200>> => {
    return axios.get(
      `/webhooks`,options
    );
  }


export const getListWebhooksQueryKey = () => [`/webhooks`];

    
export type ListWebhooksQueryResult = NonNullable<Awaited<ReturnType<typeof listWebhooks>>>
export type ListWebhooksQueryError = AxiosError<unknown>

export const useListWebhooks = <TData = Awaited<ReturnType<typeof listWebhooks>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWebhooks>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListWebhooksQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listWebhooks>>> = ({ signal }) => listWebhooks({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof listWebhooks>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Create a Webhook to receive notifications when an event occurs

 * @summary Create Webhook
 */
export const createWebhook = (
    createWebhookBody: CreateWebhookBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Webhook>> => {
    return axios.post(
      `/webhooks`,
      createWebhookBody,options
    );
  }



    export type CreateWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof createWebhook>>>
    export type CreateWebhookMutationBody = CreateWebhookBody
    export type CreateWebhookMutationError = AxiosError<unknown>

    export const useCreateWebhook = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWebhook>>, TError,{data: CreateWebhookBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWebhook>>, {data: CreateWebhookBody}> = (props) => {
          const {data} = props ?? {};

          return  createWebhook(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof createWebhook>>, TError, {data: CreateWebhookBody}, TContext>(mutationFn, mutationOptions)
    }
    